<y42-user-avatar
  *ngIf="triggeredBy.type === TriggeredByType.User"
  class="relative"
  [size]="sizePx"
  [user]="triggeredBy.data"
></y42-user-avatar>

<a
  *ngIf="triggeredBy.type === TriggeredByType.Orchestration"
  matTooltipPosition="above"
  class="flex flex-row items-center"
  [style.cursor]="clickable && state.canShowCreator ? 'pointer' : 'default'"
  [matTooltip]="showNonUserLabel ? '' : 'Orchestration'"
  (click)="showCreator()"
>
  <span [style.width.px]="sizePx" [style.minWidth.px]="sizePx" [style.height.px]="sizePx" [style.minHeight.px]="sizePx">
    <img
      [style.width.px]="sizePx"
      [style.height.px]="sizePx"
      class="orchestration-logo"
      src="assets/images/y42-product-logos/orchestration.svg"
      alt="Orchestration logo"
    />
  </span>
  <span class="ml-space-x2" *ngIf="showNonUserLabel">Orchestration</span>
</a>
